import IconComponent from 'app_components/commons/icons';
import React, {CSSProperties} from 'react';
import './newQuestionButton.scss'

export interface NewQuestionButtonProps {
  children? : any
  className?: string
  style?: CSSProperties
  inline?: boolean
  onClick?: ()=>void
}

const NewQuestionButton: React.SFC<NewQuestionButtonProps> = (props) => {
  return (
    <div
      className={`button_new_question-layout ${props.inline ? 'inline-button': ''} ${props.className ? props.className : ''}`}
      style={props.style}
      onClick={props.onClick}
    >
      <IconComponent svg='BixAddToQueue' class_name='icon-button' />
      <p>
        {props.children ? props.children : ''}
      </p>
    </div>
  );
}

export default NewQuestionButton;
